import React from 'react'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import classnames from 'classnames'
import Typography from '@paintscout/ui/components/Typography'
import type { StyleClasses } from '@paintscout/ui/styles'

type DivProps = JSX.IntrinsicElements['div']

export interface ActivityContentProps extends Omit<DivProps, 'title'> {
  classes?: StyleClasses<typeof useStyles>
  title?: React.ReactNode
}

const useStyles = makeStyles<Theme, ActivityContentProps>(
  (theme) => ({
    root: {
      paddingLeft: theme.spacing(0),
      paddingTop: theme.spacing(),
      paddingBottom: theme.spacing()
    },
    title: {
      marginBottom: 2
    },
    bubble: {
      width: 'fit-content',
      maxWidth: '100%',
      padding: theme.spacing(),
      borderRadius: theme.borderRadius.md,
      background: theme.palette.grey[100],
      '@media print': {
        border: `1px solid ${theme.palette.grey[300]}`
      }
    }
  }),
  {
    name: 'ActivityContent'
  }
)

export default function ActivityContent(props: ActivityContentProps) {
  const classes = useStyles(props)
  const { title, children, ...otherProps } = props

  return (
    <div {...otherProps} className={classnames(classes.root, props.className)}>
      {title && (
        <Typography variant="overline" component="div" className={classes.title}>
          {title}
        </Typography>
      )}
      <div className={classes.bubble}>{children}</div>
    </div>
  )
}
